export const MAX_FILES = 500;
export const MAX_FILE_SIZE = 10 * 1024 * 1024;
export const MAX_BATCH_SIZE = 500 * 1024 * 1024;
const collator = new Intl.Collator('zh-CN', { numeric: true, sensitivity: 'base' });
let nextBatch = 0;

export function validateImageFile(file) {
  if (file.name.length > 240) return '文件名不能超过 240 个字符';
  if (!/\.(jpe?g|png)$/i.test(file.name)) return '仅支持 JPG/JPEG/PNG 图片';
  if (!file.size) return '图片不能为空';
  if (file.size > MAX_FILE_SIZE) return '单张图片不能超过 10 MB';
  return '';
}

export function compareImportImages(a, b) {
  if (a.sequence != null && b.sequence != null) {
    const left = String(a.sequence).replace(/^0+/, '') || '0';
    const right = String(b.sequence).replace(/^0+/, '') || '0';
    const result = left.length - right.length || left.localeCompare(right, 'en');
    if (result) return result;
  } else if (a.sequence != null || b.sequence != null) return a.sequence != null ? -1 : 1;
  return collator.compare(a.name, b.name) || a.index - b.index;
}

export function groupImportImages(items) {
  const groups = new Map();
  for (const item of items) {
    if (!item.spu) continue;
    if (!groups.has(item.spu.id)) groups.set(item.spu.id, { spu: item.spu, images: [] });
    groups.get(item.spu.id).images.push(item);
  }
  return [...groups.values()].map(group => ({ ...group, images: group.images.sort(compareImportImages) }));
}

// 为首次提交固定展示图标记；重试沿用原请求，不能因为首图失败而重选展示图。
export function prepareImportRows(items) {
  const batch = ++nextBatch;
  for (const group of groupImportImages(items.filter(item => !item.prepared))) {
    group.images.forEach((item, index) => { item.isCover = index === 0; item.prepared = true; item.batch = batch; });
  }
  return groupImportImages(items).flatMap(group => group.images);
}

/** 跨SPU有界并发，同SPU逐张等待；停止只停止尚未开始的图片。 */
export async function runImportQueue(items, upload, { shouldStop = () => false, concurrency = 3, onChange = () => {} } = {}) {
  const groups = groupImportImages(items);
  let cursor = 0;
  async function worker() {
    while (!shouldStop() && cursor < groups.length) {
      const group = groups[cursor++];
      for (const item of group.images) {
        if (shouldStop()) break;
        item.attempted = true;
        item.uploadState = 'uploading';
        item.progress = 0;
        onChange(item);
        try {
          await upload(item, percent => { item.progress = Math.min(99, percent); onChange(item); });
          item.uploadState = 'success';
          item.error = '';
        } catch (error) {
          item.uploadState = 'failed';
          item.error = error?.message || error?.content || '上传失败，请重试';
        }
        item.progress = 100;
        onChange(item);
      }
    }
  }
  await Promise.all(Array.from({ length: Math.min(concurrency, groups.length) }, worker));
}

export function failureCsv(items) {
  const cell = value => {
    let text = String(value ?? '');
    if (/^[\s]*[=+@-]/.test(text) || /^[\t\r\n]/.test(text)) text = "'" + text;
    return '"' + text.replace(/"/g, '""') + '"';
  };
  return '\ufeff' + [['文件名', 'SPU编号', '自定义款号', '失败原因'],
    ...items.filter(item => item.uploadState === 'failed').map(item => [item.name, item.spu?.productCode, item.spu?.serialCode, item.error])]
    .map(row => row.map(cell).join(',')).join('\r\n');
}
